import {  StudentFeeDetailsActionList, StudentFeeDetailsActions, StudentFeeDetailsParams } from "../actions/studentFeesDetailsAction";
import { Action } from "../actions/types";


const initialValue : Array<StudentFeeDetailsParams> = []

const StudentFeeDetailsReducer = (state:Array<StudentFeeDetailsParams>=initialValue,action: StudentFeeDetailsActions)=>{

    switch(action.type) {
        case StudentFeeDetailsActionList.
        FETCH_STUDENT_FEE_DETAILS:

        return action.data;

        case StudentFeeDetailsActionList.CLEAR_STDUENT_FEE_DETAILS:

        return [];
        default:

        return state;

    }
}
export default StudentFeeDetailsReducer;